import { createMemo, createSignal, onMount, useContext } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { ListItemCheckboxPropsType } from '~/types/ListItemCheckbox'
import Checkbox from './Checkbox'
import { ListContext } from './List'
import ListItem from './ListItem'

export default function ListItemCheckbox(props: ListItemCheckboxPropsType) {
  const listContext = useContext(ListContext)
  const isControlled = () => props.checked !== undefined && props.onChange !== undefined
  const [internalChecked, setInternalChecked] = createSignal(props.checked || false)

  onMount(() => {
    if (props.checked !== undefined) {
      setInternalChecked(props.checked)
    }

    if (!isControlled() && listContext.setSelectedValue) {
      listContext.setSelectedValue(props.name, props.value, internalChecked())
    }
  })

  const handleChange = (event: Event & { currentTarget: HTMLInputElement; target: HTMLInputElement }) => {
    const isChecked = event.target.checked

    if (!isControlled()) {
      setInternalChecked(isChecked)

      if (listContext.setSelectedValue) {
        listContext.setSelectedValue(props.name, props.value, isChecked)
      }
    }

    if (props.onChange) {
      props.onChange(isChecked)
    }
  }

  const checked = () => (isControlled() ? props.checked! : internalChecked())

  const listItemClasses = createMemo(() => twMerge(props.class))

  return (
    <ListItem class={listItemClasses()} classList={props.classList} disabled={props.disabled}>
      <Checkbox label={props.label} checked={checked()} onChange={handleChange} disabled={props.disabled} />
    </ListItem>
  )
}
